import { sectionMetrics } from "../../model/sectionMetrics";
import { EscapeCards } from "./EscapeCards";
import { MetricRows } from "./MetricRows";
import { OtherFindings } from "./OtherFindings";
import type { SectionProps } from "./SectionProps";

// «Драки»: враги, которые ушли от игрока с низким HP, — карточкой на героя, остальные находки
// (драки без игрока, мультикиллы) карточками, метрики драк строками.
export const FightsSection = ({ report, findings }: SectionProps) => {
  const metrics = sectionMetrics(report.details, "fights");
  const escaped = findings.some((finding) => finding.code === "enemy_escaped");
  return (
    <>
      <EscapeCards findings={findings} />
      <OtherFindings
        findings={findings}
        shown={["enemy_escaped", ...(metrics.length > 0 ? (["metric"] as const) : [])]}
        hasContent={escaped || metrics.length > 0}
      />
      <MetricRows metrics={metrics} />
    </>
  );
};
